import React from "react";
import { Lock } from "@bloomberg/media-ui-icons";
import {
  createClasses,
  RoundedButton,
  RoundedToggleButton,
} from "@bloomberg/media-ui-core";
import styles from "./styles.module.css";

interface NewsletterSignUpButtonProps {
  onClick: () => void;
  onSubscriberOnlyClick: () => void;
  isSignedUp: boolean;
  isSubscriberOnly: boolean;
  isUserSubscriber?: boolean;
  isPending: boolean;
}

const NewsletterSignUpButton = React.memo(
  (props: NewsletterSignUpButtonProps) => {
    const {
      onClick,
      onSubscriberOnlyClick,
      isSignedUp,
      isSubscriberOnly,
      isUserSubscriber,
      isPending,
    } = props;

    if (isSubscriberOnly && !isUserSubscriber) {
      return (
        <RoundedButton
          disabled={isPending}
          className={styles.newsletterButton}
          colorMode="dark"
          Icon={<Lock />}
          iconPosition="left"
          onClick={onSubscriberOnlyClick}
          version="phoenix"
        >
          Subscribe
        </RoundedButton>
      );
    }

    return (
      <RoundedToggleButton
        disabled={isPending}
        className={createClasses(styles.newsletterButton, {
          [styles.signedUp]: isSignedUp,
        })}
        withIcon
        onToggle={isUserSubscriber ? onSubscriberOnlyClick : onClick}
        inactiveText="Sign Up"
        activeText="Signed Up"
        active={isSignedUp}
      />
    );
  }
);

NewsletterSignUpButton.displayName = "SuccessToast";

export default NewsletterSignUpButton;
